import React from 'react';
import './RatingStars.css';

const RatingStars = ({ rating, onRatingClick, isRated, disabled }) => {
    const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    return (
        <div className={`rating-container ${isRated ? 'rated' : ''}`}>
            <span className="rating-label">Rate:</span>
            <div className="rating-numbers">
                {numbers.map(num => (
                    <button
                        key={num}
                        type="button"
                        className={`number-rating-btn ${num <= (rating || 0) ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
                        onClick={() => !disabled && onRatingClick?.(num)}
                        disabled={disabled}
                        aria-label={`Rate ${num} out of 10`}
                    >
                        {num}
                    </button>
                ))}
            </div>
            {isRated && (
                <span className="rated-badge">✓ Rated</span>
            )}
        </div>
    );
};

export default RatingStars;